// extracted by mini-css-extract-plugin
module.exports = {"main":"index_main__EsS5i","markLabel":"index_markLabel__YDx9j","btnAll":"index_btnAll__lI0tp"};